module.exports = __webpack_public_path__ + "static/media/g4.15c36fb6.jpg";